<template>
  <div>
    <v-responsive
      v-if="item && item.link"
      :aspect-ratio="300 / 170"
      id="banner-video"
      class="banner-video"
    >
      <youtube
        :video-id="getYoutubeCode(item.link)"
        ref="youtube"
        :player-vars="playerVars"
      />
    </v-responsive>
  </div>
</template>

<script>
import { getYoutubeCode } from "../utils";

const types = {
  "right-a": 11,
  "right-b": 12,
};

export default {
  props: {
    type: {
      type: String,
      default: "right-a",
      validator: (v) => Object.keys(types).includes(v),
    },
  },
  data() {
    return {
      playerVars: {
        autoplay: 1,
        mute: 1,
        origin: this.files,
        disablekb: 1,
        enablejsapi: 1,
        loop: 1,
        modestbranding: 1,
      },
    };
  },
  mounted() {
    this.$rest("banners-video").get();
  },
  computed: {
    item() {
      return this.$rest("banners-video")
        .list.filter(({ size }) => !size || size.id === types[this.type])
        .shift();
    },
  },
  methods: {
    getYoutubeCode,
  },
};
</script>

<style lang="scss">
.banner-video {
  iframe {
    height: 100%;
    width: 100%;
  }
}
</style>
